import type { Context, MutableRefObject } from 'react';
import { createContext } from 'react';

type AppNavigationContextValue = {
	isBranchDeploy: boolean;
	resetStickySearchRef?: MutableRefObject<() => void>;
	profileMenuButtonRef?: MutableRefObject<HTMLButtonElement | null>;
	primaryDropdownItemRef?: MutableRefObject<HTMLElement | null>;
	createContentPopoverButtonRef?: MutableRefObject<HTMLElement | null>;
};

export const AppNavigationContext: Context<AppNavigationContextValue> =
	createContext<AppNavigationContextValue>({
		isBranchDeploy: false,
	});

AppNavigationContext.displayName = 'AppNavigationContext';
